import { useGroups } from '../../hooks/useGroups';
import { GroupCard } from './GroupCard';
import { CreateGroupCard } from './CreateGroupCard';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';

export const GroupListScreen = () => {
    const { data: groups, isLoading, error } = useGroups();
    const navigate = useNavigate();

    if (isLoading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;
  
    return (
        <Box sx={{ padding: 2 }}>
            {groups.map((group) => (
                <GroupCard 
                    key={group.id}
                    groupName={group.name} // Ensure this matches the field in your group objects
                    members={group.members}
                    onClick={() => navigate(`/groups/${group.id}`)}
                />
            ))}
            <CreateGroupCard onClick={() => navigate(`/new`)} />
        </Box>
    );
}
